import { mayDecide, type PersonRole } from "@/shared/roles";

/**
 * Recording for somebody else and changing their times are a manager's or an admin's. A person's
 * own hours change only through their missed check-out.
 */
export function setsOthersHours(viewer: PersonRole): boolean {
  return viewer === "admin" || viewer === "manager";
}

interface Colleague {
  readonly id: string;
  readonly role: PersonRole;
  readonly state: string;
}

/**
 * Whether the viewer may change this person's times, as the server decides it: never their own
 * unless they are the only Admin, and a Manager's or an Admin's only as an Admin.
 */
export function changesHoursOf(
  viewer: { readonly personId: string | null; readonly role: PersonRole },
  personId: string,
  people: readonly Colleague[],
): boolean {
  if (!setsOthersHours(viewer.role)) return false;
  const target = people.find((one) => one.id === personId);
  if (personId === viewer.personId) {
    return (
      viewer.role === "admin" &&
      !people.some(
        (one) =>
          one.id !== personId && one.role === "admin" && one.state === "active",
      )
    );
  }
  return !target || mayDecide(viewer.role, target.role);
}
